import { hotDesk, seatable } from './utils'
import get from 'lodash/get'
import groupBy from 'lodash/groupBy'

export const convertDepartmentSpacesToPoints = ({ ids, byId }) => {
  const sp = ids.reduce((result, id) => {
    const s = byId[id]
    return seatable(s.spaceType) || hotDesk(s.usageType) ? [...result, s] : result
  }, [])

  return sp.map(({ x, y, w, code, spaceAssignment: { department } }) => {
    const point = [x, y]
    point.w = w
    point.department = department
    point.code = code
    return point
  })
}

export const groupDepartmentCluster = (cluster) =>
  groupBy(cluster, ({ department }) => get(department, 'id'))
